import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loadingError: {
    id: 'URvXQ3',
    defaultMessage: 'Failed to load transfer order',
    description: 'Error message when transfer order fails to load',
  },
  transferDetails: {
    id: 'z6FZfP',
    defaultMessage: 'Transfer Details',
    description: 'Section title for transfer details',
  },
  originWarehouse: {
    id: '0RHfSl',
    defaultMessage: 'Origin Warehouse',
    description: 'Label for origin warehouse field',
  },
  destinationWarehouse: {
    id: 'v/lX6o',
    defaultMessage: 'Destination Warehouse',
    description: 'Label for destination warehouse field',
  },
  shippingDetails: {
    id: 'k61mi5',
    defaultMessage: 'Shipping Details',
    description: 'Section title for shipping details',
  },
  referenceNumber: {
    id: 'Ei5vRU',
    defaultMessage: 'Reference Number',
    description: 'Label for reference number field',
  },
  orderId: {
    id: 'P3tjhG',
    defaultMessage: 'Order ID',
    description: 'Label for order ID field',
  },
  orderDate: {
    id: 'wiEdxm',
    defaultMessage: 'Order Date',
    description: 'Label for order date field',
  },
  expectedDeliveryDate: {
    id: '0j1zww',
    defaultMessage: 'Expected Delivery Date',
    description: 'Label for expected delivery date field',
  },
  notes: {
    id: 's04fBz',
    defaultMessage: 'Notes',
    description: 'Label for notes field',
  },
  items: {
    id: 'NMabJi',
    defaultMessage: '{reportedItems}/{totalItems} items',
    description: 'Progress text showing received items',
  },
  saveSuccess: {
    id: 'wd9EOm',
    defaultMessage: 'Transfer order updated successfully',
    description: 'Success notification after saving transfer order',
  },
  saveError: {
    id: 'bYtsuf',
    defaultMessage: 'Failed to save transfer order',
    description: 'Error notification after failing to save transfer order',
  },
  productNameColumnHeader: {
    id: 'BYJ3n3',
    defaultMessage: 'Product Name',
    description: 'Column header for product name',
  },
  receivedColumnHeader: {
    id: '9U/r/c',
    defaultMessage: 'Received',
    description: 'Column header for received count',
  },
  costColumnHeader: {
    id: 'ZL4+oS',
    defaultMessage: 'Cost',
    description: 'Column header for cost',
  },
  totalCostColumnHeader: {
    id: 'Qaka/C',
    defaultMessage: 'Total',
    description: 'Column header for total cost',
  },
  sku: {
    id: 'SKydAb',
    defaultMessage: 'SKU: {sku}',
    description: 'Product SKU display',
  },
});
